import { Award, ShieldCheck, Users, Building } from "lucide-react";
import { COMPANY } from "../lib/config";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-28 pb-20">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="label-caps mb-3">Hakkımızda</div>
            <h1 className="font-display text-4xl sm:text-5xl text-slate-900 leading-tight mb-6">31 Yılı Aşkın Deneyimle Bursa’dan Tüm Türkiye’ye</h1>
            <p className="text-slate-600 leading-relaxed mb-4">
              SANTRAL EMLAK LTD olarak 1995 yılından bu yana kesintisiz sürdürdüğümüz gayrimenkul danışmanlığı hizmetimizle,
              müşterilerimizin alım, satım ve kiralama süreçlerinde güvenilir ve profesyonel bir yol arkadaşı olduk.
            </p>
            <p className="text-slate-600 leading-relaxed mb-4">
              Bursa Osmangazi’deki merkez ofisimizden Türkiye’nin tüm il ve ilçelerine hizmet veriyor,
              her müşterimizin sürecini titizlikle yönetiyoruz.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Yetki Belgesi No: <span className="font-semibold text-slate-900">{COMPANY.license}</span>
            </p>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1647122290875-da414489148b?w=1400" alt="Bursa" className="rounded-2xl w-full aspect-[4/5] object-cover" />
          </div>
        </div>
      </section>

      <section className="mt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: Award, k: "31+", v: "Yıl Deneyim" },
            { icon: Building, k: "1000+", v: "İşlem" },
            { icon: Users, k: "5000+", v: "Mutlu Müşteri" },
            { icon: ShieldCheck, k: "%100", v: "Şeffaf Süreç" },
          ].map((s, i) => (
            <div key={i} className="bg-white border border-slate-100 rounded-2xl p-8">
              <div className="w-11 h-11 rounded-lg bg-slate-900 text-white flex items-center justify-center mb-4"><s.icon className="w-5 h-5" /></div>
              <div className="font-display text-4xl text-slate-900">{s.k}</div>
              <div className="text-sm text-slate-500 mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="label-caps mb-3">Değerlerimiz</div>
        <h2 className="font-display text-3xl sm:text-4xl text-slate-900 mb-6">Müşteri Odaklı Hizmet Anlayışı</h2>
        <p className="text-slate-600 leading-relaxed">
          Her müşterimizle uzun soluklu ilişkiler kurmayı hedefliyor; doğru bilgilendirme, şeffaf iletişim ve
          hızlı çözüm üretme prensiplerimizi 31 yıldır aynı özenle sürdürüyoruz.
        </p>
        <Link to="/iletisim" className="mt-8 inline-flex btn-accent px-7 py-3.5 rounded-full font-semibold text-sm">Bize Ulaşın</Link>
      </section>
    </div>
  );
}
